module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_135403501343121.96eed152.jpg";